import { useState } from 'react';
import { Box, Paper, Tab, Tabs } from '@mui/material';
import PageHeader from '../common/PageHeader';
import ShopSettings from './ShopSettings';
import Users from './Users';
import RolePermissions from './RolePermissions';
import ImportStock from './ImportStock';
import { can } from '../../utils/auth';

const Settings = () => {
  const [tab, setTab] = useState(0);

  // Tabs follow the permission grid: logins and roles sit under Users, the stock
  // import under System. The backend refuses either way.
  //
  // There is no Backup tab: the nightly pg_dump runs on its own and nobody at the
  // counter should be pressing a button for it.
  const tabs: { label: string; element: JSX.Element }[] = [{ label: 'Shop Details', element: <ShopSettings /> }];
  if (can('USERS', 'view')) {
    tabs.push({ label: 'Users', element: <Users /> });
    tabs.push({ label: 'Roles', element: <RolePermissions /> });
  }
  if (can('SYSTEM', 'view')) {
    tabs.push({ label: 'Import Stock', element: <ImportStock /> });
  }

  const current = Math.min(tab, tabs.length - 1);

  return (
    <Box>
      <PageHeader title="Settings" />
      <Paper sx={{ overflow: 'hidden' }}>
        <Tabs value={current} onChange={(_event, value) => setTab(value)} variant="scrollable" scrollButtons="auto">
          {tabs.map((item) => (
            <Tab key={item.label} label={item.label} />
          ))}
        </Tabs>
        <Box sx={{ p: 3 }}>{tabs[current]?.element}</Box>
      </Paper>
    </Box>
  );
};

export default Settings;
